<template>
  <transition name="post">
    <article v-if="post" class="post">
      <header class="post__header">
        <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css"> 
        <h2 class="post__title">{{ title }}</h2>

     <!--   <h3 class="post__meta">by <router-link class="post__author"
          :to="`/by/${kebabify(author)}`">{{ author }}</router-link>
          <span class="post__sep"></span>
          <time>{{ prettyDate(published) }}</time>
        </h3>
      -->
        <blockquote class="post__subtitle">{{ description }}</blockquote>
      </header>

<div v-for="item in content" :key=content.id>
       <div v-if="isText(item)" class="post__body rte w3-container" v-html="item"></div>
       <img v-else-if="isImage(item)" class="img-thumbnail"  v-img:image v-bind:src=item>
       <img v-else-if="isGallery(item)" class="imgGallery-thumbnail"  v-img:image v-bind:src=item>              
</div>  

      <section class="post__body">
<!--      <vue-disqus v-if="commentsReady" shortname="vue-blog-demo"
          :key="post" :identifier="post" :url="`https://vue-blog-demo.netlify.com/read/${post}`"/>
 -->
      </section>

      
    </article>
  </transition>
</template>

<script>

import { kebabify, prettyDate } from '../helpers'
import Vue from 'vue';
import VueImg from 'v-img';

const vueImgConfig = {
  altAsTitle: false,
  sourceButton: false,
  openOn: 'click',
  thumbnails: true
}
Vue.use(VueImg, vueImgConfig);

export default {
  name: 'blog-post',
  resource: 'BlogPost',
  props: { post: String },
  data() {
    return {
      title: '',
      author: '',
      content: '',
      published: '',
      description: '',
      commentsReady: false
    }
  },

  watch: {
    post(to, from) {
      this.content = ''

      if (to === from || !this.post) return;

      this.commentsReady = false
      this.$getResource('post', to)
        .then(this.showComments)
    }
  },

  methods: {
    kebabify,
    prettyDate,
    isText (item) {
      return !item.startsWith('/static/')
    },
    isImage (item) {
      return item.startsWith('/static/image/')
    },
    isGallery (item) {
      return item.startsWith('/static/imageGallery/')
    },
    showComments() {
      setTimeout(() => {
        this.commentsReady = true
      }, 1000)
    },
    onLoad () {
      this.loading = false
    }
  },

  updated() {
    // this.content = ''
  },
  beforeMount() {
    if (!this.post) return;
    this.$getResource('post', this.post)
      .then(this.showComments)
  }

}
</script>
<style>
.img-thumbnail {
    padding: .25rem;
    background-color: #fff;
    border: 0.5px solid #dee2e6;
    border-radius: .15rem;
    max-width: 200px !important;
    height: auto;
    float: center;
    margin:10px 20px 10px 200px;
}
.imgGallery-thumbnail {
    padding: .25rem;
    background-color: #fff;
    border: 0.5px solid #dee2e6;
    border-radius: .15rem;
    max-width: 150px !important;
    height: auto;
    float: left;
    margin:10px 50px 10px 20px;
    
}
.figure {
    margin: 0px 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/BlogPost.vue